import { useCustom } from '@refinedev/core';
import { Spin } from 'antd';
import { Users, Building2, MessageSquare, FolderKanban, UserPlus, TrendingUp } from 'lucide-react';
import type { FC } from 'react';
import StatCard from '@/components/common/StatCard';

interface DashboardStats {
  totalUsers: number;
  totalOrganizations: number;
  totalFeedbacks: number;
  totalProjects: number;
  usersThisMonth: number;
  feedbacksThisWeek: number;
}

const OpsDashboardPage: FC = () => {
  const { data, isLoading, isError } = useCustom<{ data: DashboardStats }>({
    url: '/api/v1/admin/stats/dashboard',
    method: 'get',
  });

  const stats = data?.data?.data;

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="fc-card p-6 border-error-500">
        <p className="text-error-600 dark:text-error-500 font-medium">
          Impossible de charger les statistiques.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="fc-gradient-header rounded-2xl p-6 text-white">
        <h1 className="text-xl font-bold">Opérations</h1>
        <p className="mt-1 text-sm text-blue-100">Pilotage SaaS et métriques clés</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard title="Utilisateurs" value={stats?.totalUsers} icon={Users} iconColor="text-blue-600 dark:text-blue-400" iconBg="bg-blue-50 dark:bg-blue-900/30" />
        <StatCard title="Organisations" value={stats?.totalOrganizations} icon={Building2} iconColor="text-violet-600 dark:text-violet-400" iconBg="bg-violet-50 dark:bg-violet-900/30" />
        <StatCard title="Feedbacks" value={stats?.totalFeedbacks} icon={MessageSquare} iconColor="text-emerald-600 dark:text-emerald-400" iconBg="bg-emerald-50 dark:bg-emerald-900/30" />
        <StatCard title="Projets" value={stats?.totalProjects} icon={FolderKanban} iconColor="text-amber-600 dark:text-amber-400" iconBg="bg-amber-50 dark:bg-amber-900/30" />
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <StatCard title="Nouveaux utilisateurs" value={stats?.usersThisMonth} icon={UserPlus} iconColor="text-sky-600 dark:text-sky-400" iconBg="bg-sky-50 dark:bg-sky-900/30" />
        <StatCard title="Feedbacks récents" value={stats?.feedbacksThisWeek} icon={TrendingUp} iconColor="text-rose-600 dark:text-rose-400" iconBg="bg-rose-50 dark:bg-rose-900/30" />
      </div>
    </div>
  );
};

export default OpsDashboardPage;
